"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverAspectType = void 0;
/**
 * 封面比例
 */
var CoverAspectType;
(function (CoverAspectType) {
    CoverAspectType["CONTAIN"] = "contain";
    CoverAspectType["COVER"] = "cover";
})(CoverAspectType = exports.CoverAspectType || (exports.CoverAspectType = {}));
